export const ACCEPT_COOKIES = 'ACCEPT_COOKIES';
export const DECLINE_COOKIES = 'DECLINE_COOKIES';
export const BLOCK_COOKIES = 'BLOCK_COOKIES';
export const UNBLOCK_COOKIES = 'UNBLOCK_COOKIES';